var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row receitas"},[_c('public-header',{attrs:{"title":_vm.title}},[_c('ano-base'),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n        Aqui você encontra um resumo dos(as)\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v("\n        recebidas pela Prefeitura\n        Municipal de Santos.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        A Prefeitura Municipal de Santos, no ano de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.anoAtual))]),_vm._v("\n        até o mês de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.retornaMesComparativo))]),_vm._v(", \n        arrecadou de  \n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v("\n        um total de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.filtrarPorCodigo(_vm.receitaID).atual.vl_total))]),_vm._v("\n        de um orçamento estimado para este ano de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.filtrarPorCodigo(_vm.receitaID).atual.vl_atualizado))]),_vm._v(".\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p',[_c('bar-chart',{ref:"receita_mensal",attrs:{"chart-data":_vm.graficoHeader,"gradiente":false,"coloredLine":true,"options":{
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              labels: {
                fontColor: '#C1D1C1',
              },
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50,
                    fontColor: '#C1D1C1',
                    callback: function (value, index, values) {
                      return value.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                    },
                  },
                } ],
              xAxes: [
                {
                  maxBarThickness: 50,
                  ticks: {
                    fontColor: '#C1D1C1',
                  },
                } ],
            },
            tooltips: {
              callbacks: {
                label: function (tooltip, dataset) {
                  var xLabel = dataset.datasets[tooltip.datasetIndex].label
                  var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                  return xLabel + ': ' + yLabel
                },
              },
            },
          }}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_vm._l((_vm.breadcrumbLinks),function(link,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":link.url}},[_vm._v(_vm._s(link.descricao))])],1)}),_vm._v(" "),_c('li',{},[_vm._v(_vm._s(_vm.title))])],2)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('card',{attrs:{"data":_vm.dataCards}})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Arrecadações em Destaque")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf49726","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/public/receitas_despesas/receitas/Detalhes.vue
// module id = dGG0
// module chunks = 15